import React from "react";

function NotFoundPage() {
  return <div>404 NOT FOUND PAGE</div>;
}

export default NotFoundPage;
